"use strict";

var _interopRequireDefault = require("/root/workspace/mall_vue_JOYE/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getConfigPageInfo = getConfigPageInfo;
exports.saveConfigPage = saveConfigPage;
var _requestAuth = _interopRequireDefault(require("@/utils/requestAuth"));
var BASE = '/xyZdyDragging';

/**
 * 保存 / 发布装修配置
 * @param {Object} data 装修页提交体
 */
function saveConfigPage(data) {
  return (0, _requestAuth.default)({
    url: BASE,
    method: 'post',
    data: data
  });
}

/**
 * 装修页回显
 * 与 getXyZdyDragging 同 URL，独立方法便于语义化
 * @param {String|Number} id
 */
function getConfigPageInfo(id) {
  return (0, _requestAuth.default)({
    url: BASE + '/' + id,
    method: 'get'
  });
}